// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"s-","controlPlay":"s_","controlElement":"ta","lowerControlWrapper":"tb","lowerControlIconWrapper":"tc","lowerControlIcon":"td","show":"te"};